import axiosInstance from '@/api/axiosInstance';

export interface Skill {
  id: number;
  title: string;
  description: string;
  icon_name: string;
}

export interface Category {
  id: number;
  name: string;
  type: string;
  parent_id: number | null;
}

export interface Trade {
  id: number;
  name: string;
}

export type DifficultyLevel = 'beginner' | 'intermediate' | 'advanced';

export interface CourseMetadata {
  trades: Trade[];
  skills: Skill[];
  categories: Category[];
  difficulty_levels: DifficultyLevel[];
}

/**
 * Fetch course metadata for filter dropdowns
 * GET /api/learning-center/courses/metadata
 *
 * Returns lists of trades, skills, categories, and difficulty levels
 * Response is cached (metadata changes infrequently)
 */
export const getCourseMetadata = async (): Promise<CourseMetadata> => {
  const response = await axiosInstance.get<CourseMetadata>(
    '/api/learning-center/courses/metadata'
  );

  return response.data;
};